import { alpha, chipClasses } from '@mui/material';
// DO NOT USE alpha!
// Switch from alpha to `color-mix` function as MUI7 recommended. OKLAB!! NOT SRGB. All other files in project are
// already reworked.
// TODO: later , switch from alpha to `color-mix` function as MUI7 recommended. OKLAB!! NOT SRGB. All other files in
// project are already reworked.
// If you need to do runtime calculations, we recommend using CSS instead of JavaScript whenever possible. For example,
// adjusting the alpha channel of a color can be done using the color-mix function:
// const Custom = styled('div')(({ theme }) => ({
//   color: `color-mix(in srgb, ${theme.vars.palette.text.primary}, transparent 50%)`,
// }));
// However, if CSS approach is not possible, you can access the value directly from the theme.colorSchemes object, then apply both
// light and dark styles:
// const Custom = styled('div')(({ theme }) => ({
//   color: alpha(theme.colorSchemes.light.palette.text.primary, 0.5),
//   ...theme.applyStyles('dark', {
//     color: alpha(theme.colorSchemes.dark.palette.text.primary, 0.5),
//   }),
// }));
const getChipBoxShadow = (color, transparencyPercent = 10) => 
// `rgb(255, 255, 255) 0px 0px 0px 0px inset, color-mix(in oklab, ${color} 10%, transparent) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0) 0px 0px 0px 0px`;
`rgba(0, 0, 0, 0) 0px 0px 0px 0px, color-mix(in oklab, ${color} ${transparencyPercent}%, transparent) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px`;
// TODO: to delete all redundant comments later
export const MuiChip = {
    styleOverrides: {
        sizeMedium: {
            lineHeight: '1rem',
            // lineHeight: '1.25rem',
            padding: '.25rem 0',
        },
        sizeSmall: {
            lineHeight: '1rem',
            padding: '.125rem 0',
            // borderRadius: '.375rem',
        },
        // TODO: to delete later when below case is working.
        // labelMedium: {
        // 	// padding: '0 .5rem',
        // 	padding: '0 .375rem',
        // },
        // labelSmall: {
        // 	padding: '0 .375rem',
        // },
        root: ({ theme }) => ({
            height: 'unset',
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.helper.fontSize,
            lineHeight: '1rem',
            padding: theme.spacing(1, 0),
            // borderRadius: '9999px',
            border: 'none',
            transitionDelay: '25ms',
            // TODO: check if it is working after MUI V7 -> V9 upgrade
            variants: [
                {
                    props: { variant: 'filled', color: 'primary' },
                    style: {
                        '& .MuiChip-deleteIcon': {
                            color: theme.palette.primary.light,
                            ':hover': {
                                color: theme.palette.primary.main,
                            },
                        },
                    },
                },
                {
                    props: { variant: 'filled', color: 'secondary' },
                    style: {
                        '& .MuiChip-deleteIcon': {
                            color: theme.palette.secondary.light,
                            ':hover': {
                                color: theme.palette.secondary.main,
                            },
                        },
                    },
                },
                { props: { size: 'medium' }, style: { '& .MuiChip-deleteIcon': { fontSize: '1rem' } } },
            ],
        }),
        label: ({ theme }) => ({
            variants: [
                { props: { size: 'small' }, style: { padding: theme.spacing(0, 1.5) } },
                { props: { size: 'medium' }, style: { padding: theme.spacing(0, 1.5) } },
            ],
        }),
        // Chip with `color='default'` styling.
        outlined: ({ theme }) => [
            {
                // Unfortunately this `outlined` styling overrides `color` styling (colorPrimary, colorSecondary...).
                // That's why colors are overridden below.
                backgroundColor: theme.palette.background.light,
                color: theme.palette.text.light,
                boxShadow: getChipBoxShadow(theme.palette.neutral.main),
                ':hover': {
                    borderWidth: '1px',
                },
            },
            theme.applyStyles('dark', {
                backgroundColor: alpha(theme.palette.common.white, 0.05),
                color: theme.palette.text.muted,
                ':hover': {
                    backgroundColor: alpha(theme.palette.common.white, 0.1),
                },
            }),
        ],
        // Chip with `color='default'` styling.
        filled: ({ theme }) => [
            {
                // Unfortunately this `filled` styling overrides `color` styling (colorPrimary, colorSecondary...).
                // That's why colors are overridden below.
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.light,
            },
            theme.applyStyles('dark', {
                backgroundColor: alpha(theme.palette.common.white, 0.05),
                color: theme.palette.text.muted,
                ':hover': {
                    backgroundColor: alpha(theme.palette.common.white, 0.1),
                },
            }),
        ],
        // TODO: to delete later after check the above v7 to v9 fixes are working
        // deleteIconFilledColorPrimary: ({ ownerState, theme }) => ({
        // 	color: theme.palette.primary.light,
        // 	':hover': {
        // 		color: theme.palette.primary.main,
        // 	},
        // }),
        // deleteIconFilledColorSecondary: ({ ownerState, theme }) => ({
        // 	color: theme.palette.secondary.light,
        // 	':hover': {
        // 		color: theme.palette.secondary.main,
        // 	},
        // }),
        // deleteIconMedium: ({ ownerState, theme }) => ({
        // 	fontSize: '1rem',
        // }),
        colorPrimary: ({ theme }) => [
            {
                backgroundColor: theme.palette.primary.background,
                color: theme.palette.primary.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.primary.background,
                    color: theme.palette.primary.darker,
                    boxShadow: getChipBoxShadow(theme.palette.primary.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: theme.palette.primary.background,
                    color: theme.palette.primary.darker,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: theme.palette.primary.background,
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.primary.main, 0.15),
                    color: theme.palette.primary.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.primary.main, 0.15),
                    color: theme.palette.primary.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.25),
                    },
                },
            }),
        ],
        colorSecondary: ({ theme }) => [
            {
                backgroundColor: theme.palette.secondary.background,
                color: theme.palette.secondary.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.secondary.background,
                    color: theme.palette.secondary.darker,
                    boxShadow: getChipBoxShadow(theme.palette.secondary.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                    color: theme.palette.secondary.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.secondary.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                    color: theme.palette.secondary.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                    color: theme.palette.secondary.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.2),
                    },
                },
            }),
        ],
        colorInfo: ({ theme }) => [
            {
                backgroundColor: theme.palette.info.background,
                color: theme.palette.info.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.info.background,
                    color: theme.palette.info.darker,
                    boxShadow: getChipBoxShadow(theme.palette.info.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.info.main, 0.15),
                    color: theme.palette.info.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.info.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.info.main, 0.15),
                    color: theme.palette.info.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.info.main, 0.15),
                    color: theme.palette.info.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.info.main, 0.25),
                    },
                },
            }),
        ],
        colorSuccess: ({ theme }) => [
            {
                backgroundColor: theme.palette.success.background,
                color: theme.palette.success.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.success.background,
                    color: theme.palette.success.darker,
                    boxShadow: getChipBoxShadow(theme.palette.success.dark, 20),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.success.main, 0.15),
                    color: theme.palette.success.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.success.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    color: theme.palette.success.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    color: theme.palette.success.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.success.main, 0.2),
                    },
                },
            }),
        ],
        colorWarning: ({ theme }) => [
            {
                backgroundColor: theme.palette.warning.background,
                color: theme.palette.warning.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.warning.background,
                    color: theme.palette.warning.darker,
                    boxShadow: getChipBoxShadow(theme.palette.warning.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: theme.palette.warning.background,
                    color: theme.palette.warning.darker,
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.warning.main, 0.1),
                    color: theme.palette.warning.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.warning.main, 0.1),
                    color: theme.palette.warning.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.warning.main, 0.2),
                    },
                },
            }),
        ],
        colorError: ({ theme }) => [
            {
                backgroundColor: theme.palette.error.backgroundLight,
                color: theme.palette.error.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.error.backgroundLight,
                    color: theme.palette.error.darker,
                    boxShadow: getChipBoxShadow(theme.palette.error.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.error.main, 0.15),
                    color: theme.palette.error.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.error.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.error.main, 0.1),
                    color: theme.palette.error.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.error.main, 0.1),
                    color: theme.palette.error.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.2),
                    },
                },
            }),
        ],
        // Custom colors added to Chip component.
        colorOrange: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.orange.lightest,
                    color: theme.palette.orange.darker,
                    boxShadow: getChipBoxShadow(theme.palette.orange.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.orange.main, 0.15),
                    color: theme.palette.orange.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.orange.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.warning.main, 0.1),
                    color: theme.palette.warning.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.warning.main, 0.1),
                    color: theme.palette.warning.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.warning.main, 0.2),
                    },
                },
            }),
        ],
        colorAmber: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.amber.lightest,
                    color: theme.palette.amber.darker,
                    boxShadow: getChipBoxShadow(theme.palette.amber.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.amber.light, 0.2),
                    color: theme.palette.amber.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.amber.light, 0.3),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.amber.light, 0.1),
                    color: theme.palette.amber.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.amber.light, 0.1),
                    color: theme.palette.amber.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.amber.light, 0.15),
                    },
                },
            }),
        ],
        colorYellow: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.yellow.dark, 20),
                    color: theme.palette.yellow[800],
                    backgroundColor: theme.palette.yellow.backgroundLight,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.yellow.light, 0.2),
                    color: theme.palette.yellow.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.yellow.light, 0.3),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.yellow.light, 0.1),
                    color: theme.palette.yellow.lighter,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.yellow.light, 0.1),
                    color: theme.palette.yellow.lighter,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.yellow.light, 0.15),
                    },
                },
            }),
        ],
        colorLime: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.lime.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.lime.light, 0.2),
                    color: theme.palette.lime.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.lime.light, 0.3),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.lime.light, 0.1),
                    color: theme.palette.lime.lighter,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.lime.light, 0.1),
                    color: theme.palette.lime.lighter,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.lime.light, 0.15),
                    },
                },
            }),
        ],
        colorEmerald: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.emerald.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.emerald.main, 0.15),
                    color: theme.palette.emerald.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.emerald.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.emerald.main, 0.1),
                    color: theme.palette.emerald.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.emerald.main, 0.1),
                    color: theme.palette.emerald.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.emerald.main, 0.2),
                    },
                },
            }),
        ],
        colorTeal: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.teal.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.teal.light, 0.2),
                    color: theme.palette.teal.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.teal.light, 0.3),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.teal.main, 0.1),
                    color: theme.palette.teal.lighter,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.teal.main, 0.1),
                    color: theme.palette.teal.lighter,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.teal.main, 0.2),
                    },
                },
            }),
        ],
        colorCyan: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.cyan.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.cyan.main, 0.15),
                    color: theme.palette.cyan.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.cyan.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.cyan.light, 0.1),
                    color: theme.palette.cyan.lighter,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.cyan.light, 0.1),
                    color: theme.palette.cyan.lighter,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.cyan.light, 0.15),
                    },
                },
            }),
        ],
        colorSky: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.sky.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.sky.main, 0.15),
                    color: theme.palette.sky.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.sky.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.sky.main, 0.1),
                    color: theme.palette.sky.lighter,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.sky.main, 0.1),
                    color: theme.palette.sky.lighter,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.sky.main, 0.2),
                    },
                },
            }),
        ],
        colorViolet: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    boxShadow: getChipBoxShadow(theme.palette.violet.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.violet.main, 0.15),
                    color: theme.palette.violet.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.violet.main, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.violet.main, 0.15),
                    color: theme.palette.violet.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.violet.main, 0.15),
                    color: theme.palette.violet.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.violet.main, 0.2),
                    },
                },
            }),
        ],
        colorFuchsia: ({ theme }) => [
            {
                // // backgroundColor: theme.palette.fuchsia.background,
                // backgroundColor: alpha(theme.palette.fuchsia.main, 0.15),
                // color: theme.palette.fuchsia.darker,
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.fuchsia.lightest,
                    color: theme.palette.fuchsia.darker,
                    boxShadow: getChipBoxShadow(theme.palette.fuchsia.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.fuchsia.light, 0.15),
                    color: theme.palette.fuchsia.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.fuchsia.light, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.fuchsia.light, 0.1),
                    color: theme.palette.fuchsia.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.fuchsia.light, 0.1),
                    color: theme.palette.fuchsia.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.fuchsia.light, 0.2),
                    },
                },
            }),
        ],
        colorPink: ({ theme }) => [
            {
                // backgroundColor: theme.palette.pink.background,
                backgroundColor: alpha(theme.palette.pink.main, 0.15),
                color: theme.palette.pink.darker,
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.pink.light, 0.25),
                    },
                },
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.pink.lightest,
                    color: theme.palette.pink.darker,
                    boxShadow: getChipBoxShadow(theme.palette.pink.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.pink.light, 0.15),
                    color: theme.palette.pink.darker,
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.pink.light, 0.1),
                    color: theme.palette.pink.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.pink.light, 0.1),
                    color: theme.palette.pink.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.pink.light, 0.2),
                    },
                },
            }),
        ],
        colorRose: ({ theme }) => [
            {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: theme.palette.rose.lightest,
                    color: theme.palette.rose.darker,
                    boxShadow: getChipBoxShadow(theme.palette.rose.dark),
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.rose.light, 0.15),
                    color: theme.palette.rose.darker,
                    [`&.${chipClasses.clickable}`]: {
                        ':hover': {
                            backgroundColor: alpha(theme.palette.rose.light, 0.25),
                        },
                    },
                },
            },
            theme.applyStyles('dark', {
                [`&.${chipClasses.outlined}`]: {
                    backgroundColor: alpha(theme.palette.rose.light, 0.1),
                    color: theme.palette.rose.light,
                },
                [`&.${chipClasses.filled}`]: {
                    backgroundColor: alpha(theme.palette.rose.light, 0.1),
                    color: theme.palette.rose.light,
                },
                [`&.${chipClasses.clickable}`]: {
                    ':hover': {
                        backgroundColor: alpha(theme.palette.rose.light, 0.2),
                    },
                },
            }),
        ],
    },
};
